var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VBtn',{staticClass:"circle-icon no-print",attrs:{"fab":"","dark":""},on:{"click":_vm.click,"mouseout":_vm.mouseout}},[_c('PsIcon',{attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }